module.exports = __webpack_public_path__ + "media/img/trainings/coaches/coach-img-1-c97936f7a5a6298e3e9dd03e3d4adfa7.jpeg";